import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { API, COUNTRIES_LIST } from 'src/app/core/constants';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { WalletInfo } from 'src/app/core/models/wallet-info.model';
import { ToastrService } from 'ngx-toastr';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { StorageService } from 'src/app/core/services/storage.service';
import {environment} from 'src/environments/environment';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-saved-cards',
  templateUrl: './saved-cards.component.html',
  styleUrls: ['./saved-cards.component.scss']
})
export class SavedCardsComponent implements OnInit {

  countriesList = COUNTRIES_LIST;
  billingCountry: any = {};
  options: {};
  countryChanged: boolean = true;
  selectedCardInfo: any;
  selectedCardInfoSubscr: Subscription;
  userInfo: any;
  userInfoSubscription: Subscription;
  slugInfoSubscr: Subscription;
  slugInfo: any;
  streamInfo: any;
  getCurrency: any;
  currentLocation: any;
  // selectedTransaction: any;
  @Input('settingsData') settingsData: any = {};
  @Input('selectedTransaction') selectedTransaction: any = {};
  assets_url = environment.assets_url;
  paymentBtnSubscr: Subscription;
  currencyInfoSubscription: Subscription;
  performerInfoSubscr: Subscription;
  performerData: Subscription;
  creatorCurrency: any;
  deviceInfo: string = 'web';

  constructor(private commonSubscribeService: CommanSubscribeService,
    private toastr: ToastrService, private appPaymentService: AppPaymentTVService,
    public router: Router, private storageService: StorageService,private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.getCurrency = this.storageService.getItem('currency');
    this.deviceInfo = this.commonSubscribeService.getMobileOperatingSystem();
    this.selectedCardInfoSubscr = this.commonSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCardInfo = response;
      if (!response) {
        this.savedCardsList.forEach(e => {
          e.selectedCard = false;
        })
        // if (Object.keys(this.userInfo)?.length > 0 && !this.userInfo.is_guest)
        //   this.getPaymentMethods();
      }
    });

    this.paymentBtnSubscr = this.commonSubscribeService.updatePaymentBtn().subscribe(response =>{
      if(response != true){
        this.selectedTransaction = response;
        this.getSavedCards(this.savedCardsList);
      }
    });

    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        this.getSavedCards(this.savedCardsList);
      }
    });

    this.performerInfoSubscr = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      if(response && response.data && response.data.Data && response.data.Data.length > 0)
      this.performerData = response.data.Data[0];
    })
    this.performerData = this.commonSubscribeService.perfomerInfoData;
    if(this.performerData && this.performerData["data"] && this.performerData["data"]["Data"] && this.performerData["data"]["Data"].length > 0){
      this.performerData = this.performerData["data"]["Data"][0];
    }
    if(this.router.url.includes("/subscription-list")){
      if(this.performerData && this.performerData["plans"] && this.performerData["plans"].length > 0){
        this.creatorCurrency = this.performerData["plans"][0].currency_type;
      }
    }
    
    this.slugInfo = this.commonSubscribeService.slugInfo;
    if (this.slugInfo) {
      this.streamInfo = this.slugInfo.stream_info ? this.slugInfo.stream_info : this.slugInfo;
    }

    this.slugInfoSubscr = this.commonSubscribeService.getSlugData().subscribe(response => {
      this.slugInfo = response;
      this.streamInfo = this.slugInfo.stream_info ? this.slugInfo.stream_info : this.slugInfo;
      if (this.savedCardsList.length > 0) {
        this.getSavedCards(this.savedCardsList);
      }
    });

    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        console.log(json);
        if (val == "fail") {
          this.currentLocation = this.currentLocation ? this.currentLocation : {};
        } else {
          this.currentLocation = json;
        }
        this.setCurrency();
      });
    } else {
      this.setCurrency();
    }

    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      if (Object.keys(this.userInfo)?.length > 0 && !this.userInfo.is_guest)
        this.getPaymentMethods();
    });
    if (Object.keys(this.userInfo)?.length > 0 && !this.userInfo.is_guest)
      this.getPaymentMethods();
  }

  setCurrency(){
    let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
    let currentCode = code.includes('\"') ? JSON.parse(code) : code;
    let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency;
    this.getCurrency = localCurrency ? localCurrency : currentCode;
  }

  savedCardsList: any = [];
  cardsList = [];
  getPaymentMethods() {
    const orgId = this.streamInfo?.organization_id || this.performerData['organization_id'] || this.activatedRoute.snapshot.queryParams['organization_id'];
    let url = API.GET_PAYMENT_METODS + "?NOLOADER" + (orgId ? "&organization_id=" + orgId : "");
    this.appPaymentService.getRequest(url).subscribe(response => {
      this.savedCardsList = [];
      if (response.status == 0) {
        this.getAvailBalance();
        let resp = response['result'];
        if (resp.length > 0) {
          // if ((this.selectedPlan.current_currency != 'GBP' && this.selectedPlan.currency_type == 'USD') || this.selectedPlan.current_currency == 'USD') {
          //   gateway = 'stripeus';
          // }
          this.cardsList = resp;
          this.getSavedCards(resp);
        }
        this.commonSubscribeService.savedCardsSubject.next(this.savedCardsList);
      }
      this.commonSubscribeService.savedCardsSubject.next(this.savedCardsList);
    }, error => {
      this.toastr.error(error.error);
    });
  }

  walletInfo: WalletInfo;
  getAvailBalance() {
    this.walletInfo = this.commonSubscribeService.walletByOrg[this.commonSubscribeService.orgId];
    if (!this.walletInfo || Object.keys(this.walletInfo).length == 0) {
      this.commonSubscribeService.getAvailBalance(result => {
        this.walletInfo = result;
      }, this.commonSubscribeService.orgId);
    }
  }

  getSavedCards(resp?) {
    //debugger
    let creator_currency = this.router.url.includes('/user-dashboard/cash-wallet') ? 'USD' : this.router.url.includes("/subscription-list") ? this.creatorCurrency : this.streamInfo?.currency_type ? this.streamInfo?.currency_type : 'USD' ;
    let gateway;
    let userCur = this.walletInfo && this.walletInfo.currency && this.selectedTransaction == 'wallet' ? this.walletInfo.currency : this.getCurrency;
    if ((userCur != 'GBP' && creator_currency) || userCur == 'USD') {
      gateway = 'stripeus';
    } else {
      gateway = 'stripe';
    }
    this.savedCardsList = [];
    this.cardsList.forEach(element => {
      if (element.payment_gateway == gateway) {
        this.savedCardsList.push(element);
      }
    });
    if(this.activatedRoute.snapshot.params && Object.keys(this.activatedRoute.snapshot.params).length > 0 && this.activatedRoute.snapshot.params.channelName && Object.keys(this.activatedRoute.snapshot.params.channelName).length > 0){
    setTimeout(() => {
      let ele = document.querySelectorAll<HTMLElement>('.mat-radio-outer-circle');
      for (let i in ele)
        if (ele[i]) {
          if(this.settingsData){
            ele[i].style?.setProperty("borderColor",this.settingsData.font_secondary_color,"important");
          }
          else{
            ele[i].style?.setProperty("borderColor","","");
          }
        }
    }, 500);
  }

    this.commonSubscribeService.savedCardsSubject.next(this.savedCardsList);

  }

  // Card rows are painted with bg_primary_color, but the radio used font_secondary_color (the page text
  // colour), e.g. black on a dark-blue row. Use the first network font colour that reads on the row,
  // else black/white. Unknown row colour keeps today's styling.
  get cardRadioColor(): string {
    const row = this.toRgb(this.settingsData?.bg_primary_color);
    if (!row) return undefined;
    const readable = [this.settingsData?.font_secondary_color, this.settingsData?.font_primary_color]
      .find(c => { const rgb = this.toRgb(c); return rgb && this.contrastRatio(rgb, row) >= 3; });
    if (readable) return readable;
    return this.contrastRatio([0, 0, 0], row) >= this.contrastRatio([255, 255, 255], row) ? '#000000' : '#ffffff';
  }

  private toRgb(hex: string): number[] {
    const m = /^#?([0-9a-f]{6})$/i.exec((hex || '').trim());
    if (!m) return null;
    const n = parseInt(m[1], 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  private contrastRatio(a: number[], b: number[]): number {
    const lum = ([r, g, bl]: number[]) => {
      const lin = (c: number) => { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
      return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(bl);
    };
    const [hi, lo] = [lum(a), lum(b)].sort((x, y) => y - x);
    return (hi + 0.05) / (lo + 0.05);
  }

  selectCard(event, card) {
    this.selectedCardInfo = card;
    this.savedCardsList.forEach(e => {
      e.selectedCard = false;
      if (e.id == card.id) {
        e.selectedCard = true;
      }
    })
    this.commonSubscribeService.selectedCardSubject.next(this.selectedCardInfo);
    // let country;
    // this.countriesList.forEach(element => {
    //   if(element.alpha2code == card.billing_address.country){
    //     country = element;
    //   }
    // });
    // this.commonSubscribeService.validateZip(card.billing_address.postal_code, country.name, (result) => {
    //   if (result.status) {
    //     // this.codes = result;
    //     // let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country);
    //     // this.codes.country = country[0].alpha3code;
    //     // if (result.status) {
    //     //   this.getTaxPercentage(this.getBillingValue.zip, () => {

    //     //   });
    //     // } else {
    //     //   this.toastr.error('Invalid zip code');
    //     // }
    //   }
    // });
  }

  ngOnDestroy() {
    if (this.selectedCardInfoSubscr) {
      this.selectedCardInfoSubscr.unsubscribe();
    }
    if (this.slugInfoSubscr) {
      this.slugInfoSubscr.unsubscribe();
    }
    if(this.paymentBtnSubscr){
      this.paymentBtnSubscr.unsubscribe();
    }
    if(this.currencyInfoSubscription){
      this.currencyInfoSubscription.unsubscribe();
    }
    if(this.userInfoSubscription){
      this.userInfoSubscription.unsubscribe();
    }
    if(this.performerInfoSubscr){
      this.performerInfoSubscr.unsubscribe();
    }
  }

}
